import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "antd/dist/antd.css";
import { Menu, Dropdown, Button } from "antd";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

function NavButton() {
  const [expand, setExpand] = useState(false);

  const handleExpand = () => {
    setExpand(!expand);
  };
  const menu = (
    <Menu onClick={handleExpand}>
      <Menu.Item key="1">
        <Link to="/login-individual">Individual</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="/login-pharmacy">Pharmacy</Link>
      </Menu.Item>
    </Menu>
  );
  const menur = (
    <Menu onClick={handleExpand}>
      <Menu.Item key="1">
        <Link to="/register">Individual</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="/registerphm">Pharmacy</Link>
      </Menu.Item>
    </Menu>
  );
  return (
    <div>
      <div className="header__auth">
        <Dropdown overlay={menu}>
          <Button>
            <span>Login </span>
            <ExpandMoreIcon />
          </Button>
        </Dropdown>

        <Dropdown overlay={menur}>
          <Button>
            <span>Register </span>
            <ExpandMoreIcon />
          </Button>
        </Dropdown>
      </div>
    </div>
  )
}

export default NavButton